export const availableLangsData = LANGUAGE_SELECTIONS;

export const localeToFbLocale = {
  'fi': 'fi_FI',
  'se': 'sv_SE',
  'en': 'en_US',
  'ru': 'ru_RU',
};
